import React from 'react';
import { Form, Button, Container, Row, Col } from 'react-bootstrap';
import BlueskyComments from "../../components/BlueskyComments";
// https://www.coryzue.com/writing/bluesky-comments/
const ContactPage: React.FC = () => {
    return (
        <Container>
            <Row className="mt-5">
                <Col>
                    <h1>Contact Us</h1>
                    <Form>
                        <Form.Group className="mb-3" controlId="formBasicName">
                            <Form.Label>Name</Form.Label>
                            <Form.Control type="text" placeholder="Enter your name" />
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Label>Email address</Form.Label>
                            <Form.Control type="email" placeholder="Enter email" />
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="formBasicMessage">
                            <Form.Label>Message</Form.Label>
                            <Form.Control as="textarea" rows={3} placeholder="Enter your message" />
                        </Form.Group>

                        <Button variant="primary" type="submit">
                            Submit
                        </Button>
                    </Form>
                </Col>
            </Row>
            <Row className="mt-5">
                <Col>
                    <h2>Comments</h2>
                    <BlueskyComments uri="3lbwltnujh223" />
                </Col>
            </Row>
        </Container>
    );
}

export default ContactPage;